import React from "react";

import { FieldLabel, Input, SelectField } from "react-invenio-forms";
import { Divider, Grid } from "semantic-ui-react";
import { i18next } from "@translations/up/i18next";
import PropTypes from "prop-types";
import _get from "lodash/get";

import { AdditionalTitlesField } from "../AdditionalTitlesField";

const referredOptions = [
  { text: "", value: null },
  { text: "Not Peer-reviewed", value: "Not Peer-reviewed" },
  { text: "Peer-reviewed", value: "Peer-reviewed" },
];

const hideFields = {
  "publication-book": ["title", "alternative_titles"],
};

export const ImprintField = ({
  resourceType,
  fieldPath,
  label,
  icon,
  options,
  record,
}) => {
  const fieldsToHide = resourceType in hideFields ? hideFields[resourceType] : [];

  return (
    <>
      {label && (
        <>
          <FieldLabel htmlFor={fieldPath} icon={icon} label={label} />
          <Divider fitted />
        </>
      )}
      <Grid padded>
        {!fieldsToHide.includes("title") && (
          <Grid.Column width="16">
            <Input
              fieldPath={`${fieldPath}.title`}
              label={i18next.t("Book or report title")}
            />
            <label className="helptext mb-0">
              {i18next.t("Title of the book or report which this upload is part of")}
            </label>
          </Grid.Column>
        )}
        {!fieldsToHide.includes("alternative_titles") && (
          <Grid.Column width="16">
            <AdditionalTitlesField
              options={options}
              fieldPath={`${fieldPath}.alternative_titles`}
              recordUI={record.ui}
            />
          </Grid.Column>
        )}
        <Grid.Column width="4">
          <Input
            fieldPath={`${fieldPath}.isbn`}
            label={i18next.t("ISBN")}
            placeholder={i18next.t("e.g. 0-06-251587-X")}
          />
          <label className="helptext mb-0">
            {i18next.t("International Standard Book Number")}
          </label>
        </Grid.Column>
        <Grid.Column width="4">
          <Input
            fieldPath={`${fieldPath}.pages`}
            label={i18next.t("Pagination")}
            placeholder={i18next.t("e.g. 15-23 or 158")}
          />
          <label className="helptext mb-0">
            {i18next.t("Start and end page of a chapter")}
          </label>
        </Grid.Column>
        <Grid.Column width="4">
          <Input
            fieldPath={`${fieldPath}.volume`}
            label={i18next.t("Volume")}
            placeholder={i18next.t("e.g. 645")}
          />
        </Grid.Column>
        <Grid.Column width="4">
          <Input
            fieldPath={`${fieldPath}.sequence_number`}
            label={i18next.t("Sequence number")}
            placeholder={i18next.t("e.g. 6")}
          />
          <label className="helptext mb-0">
            {i18next.t("Item order within a larger item, e.g. chapter order (integer)")}
          </label>
        </Grid.Column>
        <Grid.Column width="4">
          <Input
            fieldPath={`${fieldPath}.series_name`}
            label={i18next.t("Series name")}
          />
        </Grid.Column>
        <Grid.Column width="4">
          <Input fieldPath={`${fieldPath}.edition`} label={i18next.t("Edition")} />
        </Grid.Column>
        <Grid.Column width="4">
          <Input
            fieldPath={`${fieldPath}.place`}
            label={i18next.t("Place")}
            placeholder={i18next.t("e.g. city, country")}
          />
          <label className="helptext mb-0">
            {i18next.t("Place where the book or report was published")}
          </label>
        </Grid.Column>
      </Grid>
    </>
  );
};

ImprintField.propTypes = {
  resourceType: PropTypes.string,
  options: PropTypes.array,
  fieldPath: PropTypes.string,
  icon: PropTypes.string,
  label: PropTypes.string,
  record: PropTypes.object,
};

ImprintField.defaultProps = {
  fieldPath: "custom_fields.imprint:book",
  icon: "book",
  label: i18next.t("Imprint"),
  options: [],
  record: {},
};
